import Vue from 'vue';
import Vuex from 'vuex';

import layout from './layout';
import snackbar from './snackbar';
import auth from './auth';
import register from '@/store/register';
import changePassword from './changePassword';
import forgot from './forgot';
import reset from './reset';
import users from './lists/usersList';
import usersForm from './forms/usersForm';
import products from '@/store/products';
import prefixs from './data_center/prefixs';
import job_positions from './data_center/job_positions';
import edu_levels from './data_center/edu_levels';
import mem_user from './data_center/users';
import user_edus from './data_center/user_edus';
import web_con_pages from './web_content/web_con_pages';
import web_con_article_pages from './web_content/web_con_article_pages';
import web_con_persons from './web_content/web_con_persons';
import uploads from './web_content/uploads';
import web_con_news from './web_content/web_con_news';
import web_con_docs from './web_content/web_con_docs';
import web_con_works from './web_content/web_con_works';
import web_con_links from './web_content/web_con_links';
import web_con_new_images from './web_content/web_con_new_images';
import web_con_activitys from './web_content/web_con_activitys';
import web_con_group_items from './web_content/web_con_group_items';
import web_con_direct_deans from './web_content/web_con_direct_deans';
import web_con_direct_dean_lists from './web_content/web_con_direct_dean_lists';
import lc_users from './centre_page/lc_users';
import lc_checkin_users from './centre_page/lc_checkin_users';

import roles from './data_center/roles';



Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    register,
    layout,
    changePassword,
    forgot,
    reset,
    snackbar,
    products,
    users,
    usersForm,
    prefixs,
    job_positions,
    edu_levels,
    mem_user,
    user_edus,
    web_con_pages,
    web_con_article_pages,
    web_con_persons,
    uploads,
    web_con_news,
    web_con_docs,
    web_con_group_items,
    web_con_works,
    web_con_activitys,
    web_con_direct_deans,
    web_con_direct_dean_lists,
    web_con_links,
    web_con_new_images,

    lc_users,
    lc_checkin_users,
    roles,

  },
});
